import { useEffect, useState } from 'react';
import './StudentInvited.scss';

export default function StudentInvitedAboutUs({
  model,
  user,
  onUpdate,
  onValidate,
  onContinue,
}) {
  const firstName = model.firstName || user?.firstName || '';
  const lastName = model.lastName || user?.lastName || '';
  const schoolName =
    model.schoolName || (user?.schools && user.schools[0]?.name) || '';
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    onValidate(!!(firstName && lastName));
    // eslint-disable-next-line
  }, [firstName, lastName]);

  return (
    <div className="student-invited-about-us">
      <div className="shell">
        <div className="step-eyebrow">Step 1 of 4</div>
        <h1 className="step-h1">Welcome!</h1>
        <p className="step-sub">Complete your information</p>

        <div className="field-row">
          <div className="field">
            <label htmlFor="confirm-first">First name</label>
            <input
              id="confirm-first"
              type="text"
              value={firstName}
              onChange={(e) =>
                onUpdate({ ...model, firstName: e.target.value })
              }
            />
          </div>
          <div className="field">
            <label htmlFor="confirm-last">Last name</label>
            <input
              id="confirm-last"
              type="text"
              value={lastName}
              onChange={(e) => onUpdate({ ...model, lastName: e.target.value })}
            />
          </div>
        </div>

        <div className="field">
          <label htmlFor="confirm-school">School</label>
          <input id="confirm-school" type="text" value={schoolName} readOnly />
        </div>

        <button
          type="button"
          className="btn-primary"
          disabled={saving || !firstName || !lastName}
          onClick={async () => {
            setSaving(true);
            await onContinue();
            setSaving(false);
          }}
        >
          {saving ? 'Saving…' : 'Continue'}
        </button>
      </div>
    </div>
  );
}
